/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Sub_Sport_GravelInputs */

const en_ui_sub_sport_gravel = /** @type {(inputs: Ui_Sub_Sport_GravelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gravel`)
};

const de_ui_sub_sport_gravel = /** @type {(inputs: Ui_Sub_Sport_GravelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gravel`)
};

/**
* | output |
* | --- |
* | "Gravel" |
*
* @param {Ui_Sub_Sport_GravelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_sub_sport_gravel = /** @type {((inputs?: Ui_Sub_Sport_GravelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Sub_Sport_GravelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_sub_sport_gravel(inputs)
	return de_ui_sub_sport_gravel(inputs)
});